export { Obfuscator, obfuscator } from "./obfuscator";
export type { ObfuscatorOptions, ObfuscatorVersion } from "./obfuscator";
